// Mediocre implementation of lodash _.get (only supporting "." separator) for client-side to avoid including lodash
/* eslint-disable @typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access */
export function get(obj: any, path: string, defaultValue?: any): any {
  let value: any = obj;

  for (const key of path.split(".")) {
    if (value === undefined || value === null) {
      return defaultValue;
    }

    value = value[key];
  }

  return value === undefined || value === null ? defaultValue : value;
}
